import React from 'react'
import { Box, Card, CardMedia, Paper, Stack, Typography } from '@mui/material'
import { useGlobalState } from 'state'
import { ObservatoryRow } from 'common/types'
import dayjs from 'dayjs'
import cameraNoneJpg from 'assets/camera-none.jpg'


type CameraValue = {
  md: string
  time: string
  url: string
}

export const CameraDetail = () => {
  const state = useGlobalState()
  const [observatory, setObservatory] = React.useState<ObservatoryRow | null>(null)
  const [timeSeries, setTimeSeries] = React.useState<CameraValue[]>([])
  const [selectedIndex, setSelectedIndex] = React.useState<number>(-1)

  React.useEffect(() => {
    setObservatory(state.observatory.selected)
  }, [state.observatory.selected])

  React.useEffect(() => {
    let arr = state.observatory.timeSeries.map(ts => {
      const jst = dayjs.utc(ts.date).local()
      return {
        md: jst.format('MM/DD'),
        time: jst.format('HH:mm'),
        url: ts.url ? ts.url : cameraNoneJpg
      }
    })
    arr = arr.slice(-6)
    setTimeSeries(arr)
    setSelectedIndex(arr.length > 0 ? arr.length - 1 : -1)
  }, [state.observatory.timeSeries])

  const showImage = () => {
    const url = timeSeries[selectedIndex].url
    window.open(url, '_blank')
  }

  return ( (observatory) &&
    <Box>

      { selectedIndex >= 0 &&
        <Card sx={{mb: 1, cursor: 'pointer'}} onClick={showImage}>
          <CardMedia component={'img'} src={timeSeries[selectedIndex].url} width="100%" style={{ maxHeight: '280px', objectFit: 'contain'}} />
        </Card>
      }

      { selectedIndex < 0 &&
        <Card sx={{mb: 1}}>
          <CardMedia component={'img'} src={cameraNoneJpg} width="100%" style={{ maxHeight: '280px', objectFit: 'contain'}} />
        </Card>
      }

      <Stack direction="row" justifyContent={'center'}>
        {timeSeries.map((ts, i) => (
          <Paper key={i} sx={{width: 60, height: 86, mr: '2px', cursor: 'pointer'}} style={{borderRadius: 0}} onClick={() => setSelectedIndex(i)}>
            <img src={ts.url} width={'60px'} height={'40px'} style={{objectFit: 'cover'}} />
            <Stack direction="column" spacing={0}>
              <Typography variant="caption" align="center" lineHeight={1.2}>{ts.md}</Typography>
              <Typography fontWeight={'bold'} fontSize={15} align="center">{ts.time}</Typography>
            </Stack>
          </Paper>
        ))}
      </Stack>

    </Box>
  )
}
